/* eslint-env jquery */

"use strict";

window.addEventListener("load", () => {
    const Swiper = require("swiper").default;
    const Navigation = require("swiper").Navigation;
    const Pagination = require("swiper").Pagination;
    const AutoPlay = require("swiper").Autoplay;

    if (!window.up1ItemGlideInitialized) {
        const carousels = $(".up-1-item-carousel-swiper");

        carousels.each(function (index, carousel) {
            const selector = "." + $(carousel).data().id + " .swiper";
            const prevButton = "." + $(carousel).data().id + " .swiper-button-prev";
            const nextButton = "." + $(carousel).data().id + " .swiper-button-next";
            const paginationSelector = "." + $(carousel).data().id + " .swiper-pagination";
            const autoPlayOptions = $(carousel).data().autoPlay ? { delay: $(carousel).data().autoPlay, pauseOnMouseEnter: true, disableOnInteraction: false } : false;

            // eslint-disable-next-line no-unused-vars
            const slider = new Swiper(selector, {
                loop: true,
                modules: [Navigation, Pagination, AutoPlay],
                pagination: {
                    el: paginationSelector,
                    clickable: true,
                },
                navigation: {
                    nextEl: nextButton,
                    prevEl: prevButton,
                },
                breakpoints: {
                    1920: {
                        slidesPerView: 1
                    },
                },
                autoplay: autoPlayOptions
            });
        });

        window.up1ItemGlideInitialized = true;
    }
});
